import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute backface-hidden w-full h-full p-3" }
const _hoisted_2 = { class: "token-header mt-0" }
const _hoisted_3 = { class: "flex items-center text-white text-lg justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = {
  key: 0,
  class: "xr-icon-token text-blue-primary mr-2"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "ml-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_13 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "text-gray-text text-md mt-2" }
const _hoisted_20 = { class: "grid grid-cols-2 my-5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-300 mb-0 text-sm" }, "Circulating Supply", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "font-bold text-yellow-bar"
}
const _hoisted_24 = {
  key: 1,
  class: "font-bold text-green-600"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-text mb-0 text-sm" }, "Current Balance", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "text-gray-text" }
const _hoisted_28 = { class: "border-t border-gray-900 py-2 pt-3" }
const _hoisted_29 = { class: "attached-games" }
const _hoisted_30 = {
  key: 0,
  class: "badge badge-dark text-white text-xs mt-6"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text text-xs py-1" }, "Linked Namespaces: ", -1)
const _hoisted_33 = { class: "absolute my-rotate-y-180 backface-hidden w-full h-full overflow-hidden p-3" }
const _hoisted_34 = {
  key: 0,
  class: "token-header mt-0"
}
const _hoisted_35 = { class: "flex items-center text-white text-lg justify-between" }
const _hoisted_36 = {
  key: 0,
  class: "xr-icon-token text-blue-primary mr-2"
}
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "ml-2" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_43 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "path4" }, null, -1)
const _hoisted_48 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "text-gray-text text-md mt-2" }
const _hoisted_50 = {
  key: 1,
  class: "grid grid-cols-2 my-5"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-300 mb-0 text-sm" }, "Circulating Supply", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "font-bold text-green-600"
}
const _hoisted_54 = {
  key: 1,
  class: "font-bold text-yellow-bar"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-text mb-0 text-sm" }, "Current Balance", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = { class: "text-gray-text" }
const _hoisted_58 = {
  key: 2,
  class: "border-t border-gray-900 py-2 pt-3"
}
const _hoisted_59 = { class: "attached-games" }
const _hoisted_60 = {
  key: 0,
  class: "badge badge-dark text-white text-xs mt-6"
}
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text text-xs py-1" }, "Linked Namespaces: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name: 'viewTokensUpdate', params: _ctx.param },
    class: _normalizeClass(["no-underline bg-black-header hover:bg-black-ori transform hover:-translate-y-2 rounded-sm block shadow-xl transition-all duration-1000 h-56 relative preserve-3d", _ctx.flip?'my-rotate-y-180':''])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.item.logo === '' || _ctx.item.logo === null)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "mr-2 w-6 h-6 rounded-full inline-block",
                    src: _ctx.assetUrl + 'blob/tokens/' + _ctx.item.tokenId + '/' + _ctx.item.logo
                  }, null, 8, _hoisted_6)),
              _createElementVNode("div", {
                class: "truncate flex-grow whitespace-nowrap",
                title: _ctx.item.title?_ctx.item.title:_ctx.item.description
              }, _toDisplayString(_ctx.item.title?_ctx.item.title:_ctx.item.description), 9, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              ((_ctx.network === 'mainnet' && _ctx.otherNetworkItem) || _ctx.network === 'testnet')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["xr-test-net inline-block mr-1 relative top-0.5 transform duration-200", _ctx.network=='mainnet'?'hover:scale-125':'']),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.network=='testnet'?(_ctx.flip = false):(_ctx.flip = true)), ["prevent"]))
                  }, _hoisted_13, 2))
                : _createCommentVNode("", true),
              ((_ctx.network === 'testnet' && _ctx.otherNetworkItem) || _ctx.network === 'mainnet')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["xr-main-net inline-block relative top-0.5 transform duration-200", _ctx.network=='testnet'?'hover:scale-125':'']),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.network=='testnet'?(_ctx.flip = true):(_ctx.flip = false)), ["prevent"]))
                  }, _hoisted_18, 2))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("small", _hoisted_19, "Asset ID: " + _toDisplayString(_ctx.item.tokenId), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _hoisted_21,
            _hoisted_22,
            (_ctx.network=='testnet')
              ? (_openBlock(), _createElementBlock("small", _hoisted_23, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.item.supply)), 1))
              : _createCommentVNode("", true),
            (_ctx.network=='mainnet')
              ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.item.supply)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_25,
            _hoisted_26,
            _createElementVNode("small", _hoisted_27, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.item.amount)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            (_ctx.item.names.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Not attached to any game yet."))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _hoisted_32,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.names, (attachedGames, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "badge badge-dark text-white text-xs truncate mr-2 font-semibold",
                      key: index
                    }, _toDisplayString(index > 0?',':'') + _toDisplayString(attachedGames), 1))
                  }), 128))
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        (_ctx.otherNetworkItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", null, [
                  (_ctx.item.logo === '' || _ctx.item.logo === null)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "mr-2 w-6 h-6 rounded-full inline-block",
                        src: _ctx.assetUrl + 'blob/tokens/' + _ctx.item.tokenId + '/' + _ctx.item.logo
                      }, null, 8, _hoisted_37)),
                  _createTextVNode(_toDisplayString(_ctx.item.title?_ctx.item.title:_ctx.item.description), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["xr-test-net inline-block mr-1 relative top-0.5 transform", _ctx.network=='testnet'?'hover:scale-125':'']),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.network=='testnet'?(_ctx.flip = false):(_ctx.flip = true)), ["prevent"]))
                  }, _hoisted_43, 2),
                  ((_ctx.network === 'testnet' && _ctx.otherNetworkItem) || _ctx.network === 'mainnet')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["xr-main-net inline-block relative top-0.5 transform", _ctx.network=='mainnet'?'hover:scale-125':'']),
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.network=='testnet'?(_ctx.flip = true):(_ctx.flip = false)), ["prevent"]))
                      }, _hoisted_48, 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("small", _hoisted_49, "Asset ID: " + _toDisplayString(_ctx.otherNetworkItem.tokenId), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.otherNetworkItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("div", null, [
                _hoisted_51,
                _hoisted_52,
                (_ctx.network=='testnet')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_53, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.otherNetworkItem.supply)), 1))
                  : _createCommentVNode("", true),
                (_ctx.network=='mainnet')
                  ? (_openBlock(), _createElementBlock("small", _hoisted_54, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.otherNetworkItem.supply)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _hoisted_55,
                _hoisted_56,
                _createElementVNode("small", _hoisted_57, _toDisplayString(_ctx.Helper.convertToCurrency(_ctx.otherNetworkItem.amount)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.otherNetworkItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                (_ctx.otherNetworkItem.names.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, "Not attached to any game yet."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _hoisted_62,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherNetworkItem.names, (attachedGames, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "badge badge-dark text-white text-xs truncate mr-2 font-semibold",
                          key: index
                        }, _toDisplayString(index > 0?',':'') + _toDisplayString(attachedGames), 1))
                      }), 128))
                    ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["to", "class"]))
}